/**
 * Ai 角色页面向用户展示的失败文案：动作（新建/保存/加载）+ 服务端/网络细节，避免只弹含糊的「保存失败」。
 */

function trimText(value) {
  return String(value == null ? '' : value).trim()
}

/**
 * 从 cola 响应、axios 错误或 Error 上取出可展示的细节。
 * @param {unknown} err
 * @returns {string}
 */
export function pickAiAssistantErrorDetail(err) {
  if (err == null) {
    return ''
  }
  if (typeof err === 'string') {
    return trimText(err)
  }
  if (typeof err !== 'object') {
    return ''
  }

  const biz =
    trimText(err.errMessage) ||
    trimText(err.response && err.response.errMessage) ||
    trimText(err.data && err.data.errMessage)
  if (biz) {
    return biz
  }

  const msg = trimText(err.message)
  if (!msg || msg === 'Error') {
    return ''
  }
  if (msg === 'Network Error') {
    return '网络异常，请稍后重试'
  }
  // 页面自己 new Error('保存失败') 时不当作「细节」，留给外层拼动作文案
  if (msg === '保存失败' || msg === '新建失败') {
    return ''
  }
  return msg
}

/**
 * @param {{ isCreate?: boolean, err?: unknown }} input
 * @returns {string} 如「新建失败：新增数据失败！」
 */
export function buildAiAssistantSaveErrorMessage(input) {
  const isCreate = !!(input && input.isCreate)
  const actionFail = isCreate ? '新建失败' : '保存失败'
  const detail = pickAiAssistantErrorDetail(input && input.err)
  if (!detail) {
    return actionFail
  }
  if (detail === actionFail || detail.startsWith(`${actionFail}：`) || detail.startsWith(`${actionFail}:`)) {
    return detail
  }
  return `${actionFail}：${detail}`
}

/**
 * @param {unknown} err
 * @returns {string}
 */
export function buildAiAssistantLoadErrorMessage(err) {
  const actionFail = '加载资源失败'
  const detail = pickAiAssistantErrorDetail(err)
  if (!detail) {
    return actionFail
  }
  if (detail === actionFail || detail.startsWith(`${actionFail}：`)) {
    return detail
  }
  return `${actionFail}：${detail}`
}

/**
 * 校验失败提示：优先 shell 具体原因，避免「请完成 0 项」。
 * @param {{ shellError?: string|null, pendingCount?: number|null }} input
 * @returns {string}
 */
export function buildAiAssistantValidationMessage(input) {
  const shellError = trimText(input && input.shellError)
  if (shellError) {
    return shellError
  }
  const pendingCount = Number(input && input.pendingCount)
  const count = Number.isFinite(pendingCount) && pendingCount > 0 ? Math.floor(pendingCount) : 0
  if (count > 0) {
    return `请完成 ${count} 项必填内容`
  }
  return '请检查并完成必填内容'
}
